import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { isArray } from 'lodash';

@Component({
    // styleUrls: ['error.component.scss'],
    templateUrl: 'http-error.component.html'
})
export class HttpErrorComponent {

    public isArray = isArray;

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: {message: string; meta: Array<{field: string; message: string}> | string}
    ) {
    }
}
